var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"check-table"},_vm._l((_vm.data),function(row,index){return _c('check-row',{key:index,attrs:{"col-count":row.colCount,"odds":row.odds,"title":row.title,"titleColor":row.titleColor,"selectedOddsItems":_vm.selectedOddsItems},on:{"row-selection-change":_vm.handleRowSelectionChange}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }